/**
 * Body of the medical PA form: the left section-navigation column and the
 * dynamic {@link MedicalPaForm} on the right.
 *
 * @module medicalPaForm/components/medicalPaFormContent
 */
import FormSections from "../../../components/formSections/formSections";
import { MedicalPaFormContentProps } from "../types";
import MedicalPaForm from "./medicalPaForm";

/**
 * Renders the section navigation and the configurable PA form, wiring section
 * clicks/scrolls back to the layout's active-section state.
 *
 * @param props - See {@link MedicalPaFormContentProps}.
 * @returns The form body element.
 */
const MedicalPaFormContent = ({
  id,
  singleMedicalPaFormConfig,
  latestMedicalPaFormData,
  activeSectionId,
  setActiveSectionId,
}: MedicalPaFormContentProps) => {
  return (
    <div className="medical-pharma-pa-form__body content flex flex-1 overflow-hidden">
      <div className="medical-pharma-pa-form__body form-sections w-1/5">
        <FormSections
          formConfiguration={
            singleMedicalPaFormConfig ? [singleMedicalPaFormConfig] : undefined
          }
          matchedKey={singleMedicalPaFormConfig?.id ?? ""}
          activeSection={
            activeSectionId ? `section-${activeSectionId}` : undefined
          }
        />
      </div>
      <div className="medical-pharma-pa-form__body main-form h-full w-4/5 overflow-auto overflow-x-hidden border border-primaryGray-16 p-4">
        <div className="form-name--container mb-4 flex w-full justify-between">
          <div className="form-title flex-1 rounded bg-secondaryYellow-11 p-3 text-body font-bold">
            {singleMedicalPaFormConfig?.data?.formTitle ?? ""}
          </div>
        </div>

        <MedicalPaForm
          docId={id ?? ""}
          sectionOnClick={(value) => {
            setActiveSectionId(value as string);
          }}
          scrollSectionId={(value) => {
            setActiveSectionId(value as string);
          }}
          formConfiguration={singleMedicalPaFormConfig?.data ?? undefined}
          latestMedicalPaFormData={latestMedicalPaFormData ?? undefined}
        />
      </div>
    </div>
  );
};

export default MedicalPaFormContent;
